import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "./SelectedArticles.module.css";
import { ProductCard } from "@coworker/apprestructured/src/scan-and-search/components/product-card/ProductCard";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import TrashCanIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/TrashCanIconPath";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";

interface SelectedArticlesProps {
  items: Item[];
  onDeleteArticle: (no: string) => void;
}

export const SelectedArticles = ({
  items,
  onDeleteArticle,
}: SelectedArticlesProps) => {
  const [searchHistory, setSearchHistory] = useUserPreference<string[]>(
    profilePreferences.SEARCH_HISTORY,
    []
  );
  return (
    <ul>
      {items.map((article) => (
        <li key={article.no} className={styles["li"]}>
          <ProductCard
            product={article}
            setSearchHistory={setSearchHistory}
            searchHistory={searchHistory}
            handleProductClick={() => {}}
          />
          <FixaButton
            type="secondary"
            iconOnly
            ssrIcon={TrashCanIconPath}
            size="small"
            onClick={() => onDeleteArticle(article.no)}
          />
        </li>
      ))}
    </ul>
  );
};
